// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__LeccQ","bigScore":"style__bigScore__lIoP3","targetIndicator":"style__targetIndicator__xbaTE"};